import { useEffect, useState } from 'react';

export const usePasswordValidation = (password: string) => {
    const [min, setMin] = useState(false);
    const [word, setWord] = useState(false);
    const [num, setNum] = useState(false);
    const [char, setChar] = useState(false);

    const validations = {
        minReg: new RegExp(/.{8,}/),
        wordReg: new RegExp(/(?=.*?[A-Z])(?=.*?[a-z])/),
        numReg: new RegExp(/(?=.*?[0-9])/),
        charReg: new RegExp(/(?=.*?[#?!@$%^&*-])/),
    };

    useEffect(() => {
        if (validations.minReg.test(password)) {
            setMin(true);
        } else {
            setMin(false);
        }

        if (validations.wordReg.test(password)) {
            setWord(true);
        } else {
            setWord(false);
        }

        if (validations.numReg.test(password)) {
            setNum(true);
        } else {
            setNum(false);
        }

        if (validations.charReg.test(password)) {
            setChar(true);
        } else {
            setChar(false);
        }
    }, [password]);

    return { min, word, num, char };
};